module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-1411e92c485e09017f4301189df54dd8.jpg";